// src/utils/mappers/taxCreditMapper.ts

import { PurchaseDetail, PurchaseFormValues } from '../../types/purchases/BasePurchase';

export const mapTaxCreditPurchaseToFormValues = (
  purchase: PurchaseDetail
): PurchaseFormValues => {
  const {
    id,
    documentNumber,
    purchaseDate,
    documentType,
    supplier,
    paymentCondition,
    paymentMethod,
    comments,
    cancellationReason,
    taxCreditDetails,
  } = purchase;

  return {
    id,
    documentNumber,
    purchaseDate,
    documentType,
    supplier,
    paymentCondition: paymentCondition || null,
    paymentMethod: paymentMethod || null,
    comments: comments || '',
    cancellationReason: cancellationReason || '',
    products: taxCreditDetails?.products || [],
    taxableSubtotal: taxCreditDetails?.taxableSubtotal,
    calculatedIVA: taxCreditDetails?.calculatedIVA,
    withheldIVA: taxCreditDetails?.withheldIVA,
    total: taxCreditDetails?.total ?? 0,
  };
};
